<template>
  <section>
    <h5>{{ $t('DASHBOARD.LATEST_TEMPLATE_DOCUMENTS')}}</h5>
    <b-card no-body>
      
      <template-item v-for="item in items" :item="item" :small="1" :key="item.document.id"></template-item>
  
      <b-card-body
        class="text-center"
        v-if="items.length == 0"
      >{{ $t('DASHBOARD.NO_TEMPLATE_DOCUMENTS')}}</b-card-body>

      <b-card-footer class="clickable text-center">
        <router-link :to="{ name: 'Templates.Team' }">
          <i class="fal fa-file-edit" />
          {{$t('DASHBOARD.GOTO_TEMPLATE_DOCUMENTS')}}
        </router-link>
      </b-card-footer>
    </b-card>
  </section>
</template>
<script>
import TemplateItem from "@/components/Templates/TemplateItem";
export default {
  components: {
    TemplateItem
  },
  data() {
    return {
      page: 0,
      limit: 3,
      items: [],
      totalItems: 0,
      user: this.$store.getters["auth/user"]
    };
  },
  methods: {
    getTemplateDocuments: function() {
      let self = this;
      this.$http
        .post(process.env.VUE_APP_BACKEND + "/templates/team/list", {
          page: this.page,
          limit: this.limit,
          searchText: ''
        })
        .then(response => {
          self.items = response.data.items;
          self.totalItems = response.data.total;
        })
        .catch(() => {
          self.$noty.error(self.$t("ERROR.COULD_NOT_FETCH_DATA"));
        });
    }
  },
  mounted: function() {
    this.getTemplateDocuments();
  }
};
</script>
<style>
</style>
